import { action } from '@ember/object';
import Component from '@glimmer/component';
import type * as Highcharts from 'highcharts';

interface GeneralChartsChartUpdaterSignature {
  Args: {};
  Blocks: {
    default: [chartUpdater: GeneralChartsChartUpdater];
  };
}

// The Chart Updater is used when the chart needs to be reflowed at a certain event
// this is useful specifically for web components as their initialization isn't aligned with the ember components
export default class GeneralChartsChartUpdater extends Component<GeneralChartsChartUpdaterSignature> {
  chart: Highcharts.Chart | null = null;

  @action onUpdateChartReference(chart: Highcharts.Chart): void {
    this.chart = chart;
  }

  @action reflowChart(): void {
    this.chart?.reflow();
  }

  <template>{{yield this}}</template>
}
